module.exports = __webpack_public_path__ + "webpack/1776841320215/img/logo.68236592.png";